import VueApexCharts from 'vue-apexcharts'
import api from '../../services/service_report'
import Swal from 'sweetalert2'
import moment from 'moment'
import Con from '../../../static/config.json'

export default {
  data() {
    const baseUrl = Con.URL
      .replace(/index\.php\/?$/, '')
      .replace(/\/api\/?$/, '/')
    return {
      dateNow: this.dateMonth(new Date()),
      data_Overdue: '',
      data_list: [],
      data_sum_list: '',
      data_month: '',
      pdf_url: baseUrl + 'pdf/overdue_pdf.php',
      excel_url: baseUrl + 'excel/overdue_excel.php',
      sum_pdf_url: baseUrl + 'pdf/overdue_sum_pdf.php',
      sum_excel_url: baseUrl + 'excel/overdue_sum_excel.php',
      qty: [],
      month_start: '',
      month_end: '',
      oldData: this.dateMonth(new Date()),
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      }
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  methods: {
    getOverdue() {
      this.data_list = []
      this.$store.state.isLoading = true
      api.getReportoverdue({
          date: moment(this.dateNow).format('YYYY-MM-DD'),
          month_start: this.month_start,
          month_end: this.month_end,
          active_page: 1,
          per_page: 10000000
        },
        this.header,
        result => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            this.data_list = result.data.pagination
            if (this.oldData != this.dateNow || this.qty.length == 0) {
              this.oldData = this.dateNow
              this.data_list.forEach(v => {
                this.qty.push(v['num_count'])
              })
            }
            this.data_Overdue = JSON.stringify(result.data.pagination)
            this.data_month = this.monthYearFormat(this.dateNow)
            console.log(result.data)
          } else {
            Swal.fire('ดึงข้อมูลรายงาน', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getSumOverdue(type) {
      this.$store.state.isLoading = true
      api.getReportsumoverdue({
          date: moment(this.dateNow).format('YYYY-MM-DD'),
          month_start: this.month_start,
          month_end: this.month_end,
          active_page: 1,
          per_page: 10000000
        },
        this.header,
        result => {
          if (result.response === true) {
            this.data_sum_list = JSON.stringify(result.data.pagination)
            this.data_month = this.monthYearFormat(this.dateNow)
            setTimeout(() => {
              if (type == 1) {
                $('#sum_pdf').submit()
              } else {
                $('#sum_excel').submit()
              }
              this.$store.state.isLoading = false
            }, 2000)
          } else {
            Swal.fire('ดึงข้อมูลรายงาน', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted() {
    this.getOverdue()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/overdue_report.js